// extracted by mini-css-extract-plugin
export default {"Container":"BasePage_Container__gOPMH","Content":"BasePage_Content__YFJ6v","ScrollbarsView":"BasePage_ScrollbarsView__gJrqI"};